import React, { useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import GuestPlayerDialog from '../components/guestplayer.dialog';
import Button from '@mui/material/Button';
import { sortPlayers } from '../util/sort';

const PlayerSelect = ({ players, updatePlayers, playersRef, maxSelect, canAddGuest }) => {
    const [guestDialogOpen, setQuestDialogOpen] = useState(false);

    return (
        <div className='s4g-player-input'>
            {players.map(function (player) {
                return (
                    <div key={player.id}>
                        <FormGroup ref={playersRef}>
                            <FormControlLabel control={<Checkbox
                                checked={player.participating}
                                disabled={maxSelect && player.participating === false && players.filter(p => p.participating).length >= maxSelect}
                                onChange={() => {
                                    let updatedPlayers = [...players];
                                    let updatedPlayer = updatedPlayers.find(p => p.name === player.name);
                                    updatedPlayer.participating = !updatedPlayer.participating;

                                    updatePlayers(updatedPlayers.sort((a, b) => sortPlayers(a, b)));
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />} label={`${player.name} ${player.isGuest ? '(Gäst)' : ''}`} />
                        </FormGroup>
                    </div>
                );
            })}
            {canAddGuest && <Button variant="outlined" onClick={() => setQuestDialogOpen(true)}>+ Lägg till gäst</Button>}
            <GuestPlayerDialog players={players} dialogOpen={guestDialogOpen} setDialogOpen={setQuestDialogOpen} addGuestPlayer={name => {
                if (players.filter(_ => _.name.toLowerCase() === name.toLowerCase()).length === 0) {
                    let updatedPlayers = [...players];
                    let guestPlayer = {
                        id: name,
                        name: name,
                        teeType: '',
                        isGuest: true,
                        participating: true,
                        alreadyRegistered: false
                    };

                    updatedPlayers.push(guestPlayer);
                    updatePlayers(updatedPlayers.sort((a, b) => sortPlayers(a, b)));
                }
                setQuestDialogOpen(false);
            }} />
        </div>
    );
}

export default PlayerSelect;
